module.exports = __webpack_public_path__ + "img/xr_banner_m.28fdee42.jpg";